import { client } from "../../client";
import { CREATE_LOG_MUTATION } from "./mutation";

// 로그 타입 상수
export const LogType = {
  AD: "AD",
  GENERAL_LOG: "GENERAL_LOG",
  TEST: "TEST",
};

// 이벤트 타입 상수
export const EventType = {
  CLICK: "CLICK",
  VIEW: "VIEW",
};

// 세션 ID를 가져오는 유틸리티 함수
export const getSessionId = async () => {
  return new Promise((resolve) => {
    const checkSessionId = () => {
      const sessionId = sessionStorage.getItem("sessionId");
      if (sessionId) {
        resolve(sessionId);
      } else {
        setTimeout(checkSessionId, 50);
      }
    };
    checkSessionId();
  });
};

// 로그 생성 기본 함수
export const createLog = async (
  eventType,
  log_type,
  accountId,
  adId,
  brand
) => {
  try {
    const sessionId = await getSessionId();

    console.log("mutate start...");

    const result = await client.mutate({
      mutation: CREATE_LOG_MUTATION,
      variables: {
        create_log_input: {
          event_type: eventType,
          log_type: log_type,
          account_id: accountId,
          ad_id: adId,
          brand: brand,
          user_session_id: parseInt(sessionId),
        },
      },
    });

    console.log("mutate end...");
    return result;
  } catch (error) {
    console.error("로그 생성 오류:", error);
    return null;
  }
};

// 클릭 로그 생성 함수
export const createClickLog = async (item) => {
  const { account_id, brand } = item;
  console.log("createClickLog", account_id, brand);

  try {
    await createLog(EventType.CLICK, null, account_id, null, brand);
    return;
  } catch (error) {
    console.error("클릭 로그 생성 오류:", error);
    return;
  }
};

// 뷰 로그 생성 함수
export const createViewLog = async (item) => {
  const { log_type, account_id, ad_id } = item;
  console.log("createViewLog...!", log_type, account_id, ad_id);
  try {
    // eventType,
    // log_type,
    // accountId,
    // adId,
    // brand
    const result = await createLog(
      EventType.VIEW,
      log_type,
      account_id,
      ad_id,
      null
    );
    console.log("result...", result);
    return true;
  } catch (error) {
    console.error("뷰 로그 생성 오류:", error);
    return false;
  }
};
